import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import settings from './settings'
import router, { constantRoutes } from '@/router'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect']

const getPageTitle = (key: string) => {
  const hasKey = key
  if (hasKey) {
    const pageName = key
    return `${pageName} - ${settings.title}`
  }
  return `${settings.title}`
}

router.beforeEach(async (to: Route, _: Route, next: any) => {
  NProgress.start()
  if (UserModule.token) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (UserModule.roles.length === 0) {
        try {
          await UserModule.GetUserInfo()
          const accessRoutes:any = await PermissionModule.GenerateRoutes(UserModule.menuList)
          console.log(accessRoutes)

          // resetRouter()
          accessRoutes.forEach((currentRouter:any) => {
            router.addRoute(currentRouter)
          })
          // console.log(39, constantRoutes)

          setTimeout(() => {
            next({ ...to, replace: true })
          }, 200)
        } catch (err) {
          UserModule.ResetToken()
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to: Route) => {
  NProgress.done()

  document.title = getPageTitle(to?.meta?.title)
})
